import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { EPageResponse, IPageGetPage } from "../../models/page";
import { FaqItem } from "../../models/faq";

const API = ApiEndpoints.FAQ;
const baseURL = envConfig.API_ENDPOINT;

const getAll = async (
  language: string,
): Promise<IBaseResponseModel<FaqItem[]>> => {
  return api.get(baseURL, API.GetAll.url + "?language=" + language);
  //return res;
};

const getSingleByObjId = async (
  objId: string,
): Promise<IBaseResponseModel<FaqItem[]>> => {
  return api.get(baseURL, API.GetSingle.url + "?objId=" + objId);
  //return res;
};

const createOrUpdate = async (
  data: any,
): Promise<IBaseResponseModel<FaqItem[]>> => {
  return api.put(baseURL, API.CreateOrUpdate.url, data);
  //return res;
};

const FaqService = {
  getAll,
  getSingleByObjId,
  createOrUpdate,
};

export default FaqService;
